module.exports = __webpack_public_path__ + "assets/img/Arty_005.d62d29a4-ps.jpg";